import { userClient, accessToken, guestClient } from './auth';

// 내 상품문의 목록 조회하기
export async function getMyProductQna({ pageNumber, pageSize }: { pageNumber: number; pageSize: number }) {
  return await userClient.get(`/profile/product-inquiries?pageNumber=${pageNumber}&pageSize=${pageSize}`);
}

// 해당 상품문의 목록 조회하기
export async function getProductQna({
  pageNumber,
  pageSize,
  productNo,
}: {
  pageNumber: number;
  pageSize: number;
  productNo: number;
}) {
  if (accessToken) {
    return await userClient.get(
      `/products/${productNo}/inquiries?pageNumber=${pageNumber}&pageSize=${pageSize}&answered=true&isMyInquiries=false`,
    );
  } else {
    return await guestClient.get(
      `/products/${productNo}/inquiries?pageNumber=${pageNumber}&pageSize=${pageSize}&answered=true&isMyInquiries=false`,
    );
  }
}

// 상품문의 등록하기
export async function addProductQna({ type, title, content, productNo }: any) {
  return await userClient.post(`/products/${productNo}/inquiries`, {
    type: type,
    title: title,
    content: content,
    productNo: productNo,
  });
}

// 상품문의 삭제하기
export async function delProductQna({ inquiryNo }: { inquiryNo: number }) {
  return await userClient.delete(`/products/inquiries/${inquiryNo}`);
}

// 상품문의 수정하기
export async function putProductQna({ type, title, content, productNo }: any) {
  return await userClient.put(`/products/inquiries/${productNo}`, {
    type: type,
    title: title,
    content: content,
    // inquiry: productNo,
  });
}
